import { normalizeTonAddress } from './chunk-YJFBF252.js';
import { resolveChain } from './chunk-ITKHZFQN.js';

// src/chains/address-ref.ts
function parseAddressReference(value) {
  const raw = (value ?? "").trim();
  if (normalizeTonAddress(raw)) return { address: raw, chain: null };
  const last = raw.lastIndexOf(":");
  if (last <= 0 || last === raw.length - 1) return { address: raw, chain: null };
  const first = raw.indexOf(":");
  const alias = raw.slice(0, first);
  const native = raw.slice(first + 1);
  if (resolveChain(alias)?.caip2.startsWith("tvm:") && normalizeTonAddress(native)) {
    return { chain: alias, address: native };
  }
  for (let cut = last; cut > 0; cut = raw.lastIndexOf(":", cut - 1)) {
    const chain = raw.slice(0, cut);
    if (resolveChain(chain) || /^[a-z0-9-]{3,8}:[^:]+$/.test(chain)) {
      return { chain, address: raw.slice(cut + 1) };
    }
  }
  return { chain: raw.slice(0, last), address: raw.slice(last + 1) };
}

export { parseAddressReference };
//# sourceMappingURL=chunk-QDBNU24N.js.map
//# sourceMappingURL=chunk-QDBNU24N.js.map